import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ButtonBase from '@mui/material/ButtonBase';
import { Row } from 'further-ui/components/Layout';

type Props = {
  unexpandedRowLimit: number;
  totalRows: number;
  isExpanded: boolean;
  onExpandToggle: () => void;
};

const TableViewMoreFooter: React.FC<Props> = ({
  onExpandToggle,
  isExpanded,
  totalRows,
  unexpandedRowLimit,
}) => {
  return (
    <ButtonBase onClick={onExpandToggle}>
      <Row spacing="xxs" centered>
        {isExpanded ? (
          <>
            Show less <ExpandLess fontSize="small" />
          </>
        ) : (
          <>
            View {totalRows - unexpandedRowLimit} more{' '}
            <ExpandMore fontSize="small" />
          </>
        )}
      </Row>
    </ButtonBase>
  );
};

export default TableViewMoreFooter;
